import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "recent-sales-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "basic-table table-responsive" }
const _hoisted_5 = { class: "table mb-0" }
const _hoisted_6 = { class: "fw-semibold text-body" }
const _hoisted_7 = { class: "employee-info d-flex align-items-center" }
const _hoisted_8 = { class: "img rounded-circle" }
const _hoisted_9 = ["alt", "src"]
const _hoisted_10 = { class: "d-block fw-semibold" }
const _hoisted_11 = { class: "fw-semibold text-body" }
const _hoisted_12 = { class: "fw-semibold text-body" }
const _hoisted_13 = { class: "payment-method-info d-flex align-items-center" }
const _hoisted_14 = ["alt", "src"]
const _hoisted_15 = { class: "d-block" }
const _hoisted_16 = { class: "d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap pt-3" }
const _hoisted_17 = { class: "fs-12 fw-medium" }
const _hoisted_18 = { "aria-label": "Page navigation example" }
const _hoisted_19 = { class: "pagination mb-0 justify-content-center" }
const _hoisted_20 = { class: "page-item" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "page-item" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Recent Sales"),
        _createElementVNode("select", {
          class: "form-select month-select bg-gray border-0 form-control",
          "aria-label": "Default select example"
        }, [
          _createElementVNode("option", null, "Weekly"),
          _createElementVNode("option", { selected: "" }, "Monthly"),
          _createElementVNode("option", null, "Yearly")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Ref"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Customer"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Grand Total"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Paid"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Payment Method"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "fw-bold"
                }, "Status")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedCustomers, (customer) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: customer.ref
                }, [
                  _createElementVNode("td", _hoisted_6, "#" + _toDisplayString(customer.ref), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          alt: customer.name,
                          src: customer.image,
                          class: "rounded-circle"
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(customer.name), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_11, " $" + _toDisplayString(customer.grandTotal), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["fw-semibold", 
                    customer.paid === 'Paid' ? 'text-success' : 'text-danger'
                  ])
                  }, _toDisplayString(customer.paid), 3),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("img", {
                        alt: customer.paymentMethod,
                        src: customer.paymentMethodImage
                      }, null, 8, _hoisted_14),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(customer.paymentMethod), 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["trezo-badge", customer.status.toLowerCase()])
                    }, _toDisplayString(customer.status), 3)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, " Showing " + _toDisplayString(_ctx.startIndex + 1) + " to " + _toDisplayString(_ctx.endIndex) + " of " + _toDisplayString(_ctx.customers.length) + " Results ", 1),
          _createElementVNode("nav", _hoisted_18, [
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", _hoisted_20, [
                _createElementVNode("button", {
                  class: "page-link icon",
                  "aria-label": "Previous",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
                  disabled: _ctx.currentPage === 1
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_left", -1)
                ]))], 8, _hoisted_21)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "page-item",
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["page-link", { active: page === _ctx.currentPage }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_22)
                ]))
              }), 128)),
              _createElementVNode("li", _hoisted_23, [
                _createElementVNode("button", {
                  class: "page-link icon",
                  "aria-label": "Next",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                  disabled: _ctx.currentPage === _ctx.totalPages
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "material-symbols-outlined" }, "keyboard_arrow_right", -1)
                ]))], 8, _hoisted_24)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}